import { Box } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt'

export const FilterInput = (props) => {
  const { label, placeholder='contains', onChange, marginB, disabled ,onBlur} = props
  return (
    <Box sx={{ display: 'flex', marginBottom: marginB ? '4px' : '0' }} className="filter-box">
      <input
        className={`field ${disabled ? 'disabled' : ''}`}
        name="searchInput"
        placeholder={label || placeholder}
        onChange={onChange}
        onBlur={onBlur}
        style={{ width: 'calc(100% - 16px)' }}
        disabled={disabled}
      />
      <FilterAltIcon />
    </Box>
  )
}
